export default class SyncRecipes {
  constructor() {
    this.button = document.getElementById('sync-recipes');

    this.button.addEventListener('click', e => this.syncRecipes(e));
  }

  async syncRecipes(e) {
    const { action: ajaxAction } = e.target.dataset;
    const recipesNoticeId = 'sync-recipes-notice';

    this.removeNoticeElement(recipesNoticeId);
    this.setButtonAsLoading();

    try {
      const response = await fetch(`${ajaxurl}?action=${ajaxAction}`);

      if(!response.ok) {
        this.insertNoticeMessage(recipesNoticeId, 'error', 'Não foi possível sincronizar as receitas.');
      } else {
        this.insertNoticeMessage(recipesNoticeId, 'success', 'Receitas sincronizadas com sucesso.');
      }

    } catch (e) {
      this.insertNoticeMessage(recipesNoticeId, 'error', 'Não foi possível sincronizar as receitas.');
    } finally {
      this.unsetButtonAsLoading();
    }
  }

  removeNoticeElement(id) {
    const recipesNotice = document.getElementById(id);

    recipesNotice?.remove();
  }

  insertNoticeMessage(noticeId, noticeType, message) {
    this.button.insertAdjacentHTML(
      'afterend',
      `<div id="${noticeId}" class="notice notice-${noticeType}"><p>${message}</p></div>`
    );
  }

  setButtonAsLoading() {
    this.button.style.opacity = 0.5;
    this.button.style.cursor = 'normal';
    this.button.style.pointerEvents = 'none';
  }

  unsetButtonAsLoading() {
    this.button.style.opacity = 1;
    this.button.style.cursor = 'pointer';
    this.button.style.pointerEvents = 'initial';
  }
}
